<template>
  <v-card variant="text">
    <v-select
      v-model="filter"
      label="Filter nach Anzahl Tasten"
      :items="
        maxKeys.map((numKey) => ({
          value: numKey,
          title: numKey,
        }))
      "
    />
    <v-container
      ><v-row>
        <v-col v-for="layout of filteredLayouts" :key="layout.value" cols="3">
          <div>{{ MAX_FLEX_TYPE_MAP[layout.value] }}</div>
          <MaxFlexLayoutView :layout="layout" @click="selectLayout" />
        </v-col>
      </v-row>
    </v-container>
    <v-card-actions>
      <v-btn variant="outlined" color="primary" class="my-2" @click="cancel"
        >Abbrechen</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import {
  MAX_FLEX_LAYOUTS,
  MAX_FLEX_TYPE_MAP,
  MaxFlexLayout,
} from '@/apps/brelag/common/models/maxflex/maxflex'
import MaxFlexLayoutView from '@/apps/brelag/mandator-user/components/editor/maxflex/MaxFlexLayoutView.vue'

const emit = defineEmits(['selected', 'cancel'])
const layouts: MaxFlexLayout[] = MAX_FLEX_LAYOUTS
const filter = ref('2')

const maxKeys = computed(() => {
  const keys = [...Array(9).keys()].map((key) => key.toString())
  keys[0] = 'Alle'
  return keys
})

const filteredLayouts = computed((): MaxFlexLayout[] => {
  if (filter.value !== null && filter.value !== 'Alle') {
    return layouts.filter((layout) => {
      return layout.numKeys === parseInt(filter.value)
    })
  } else {
    return layouts
  }
})

function selectLayout(layoutValue: number) {
  emit('selected', layoutValue)
}

function cancel() {
  emit('cancel')
}
</script>

<style lang="scss" scoped></style>
